<section>
  <div class="my-2">
    <form novalidate [formGroup]="formInvoicingModelDetail">
      <div class="row p-1">
        <div class="col field-concept-invoicing">
          <app-custom-autocomplete formControlName="conceptInvoicingId" [labelText]="'Concepto Fra.'"
            [list]="listConceptInvoicing" [recovery]="true" [required]="true"
            (onChangeSelect)="getInvoicingModelDetailByKeys($event)"></app-custom-autocomplete>
        </div>
        <div class="col field-alter-concept" *ngIf="conceptInvoicingType === 1 ">
          <app-custom-input-text formControlName="alterConcept" [labelText]="'Concepto Alt.'"></app-custom-input-text>
        </div>
        <div class="col field-sw-aiu d-flex align-items-end mb-1" *ngIf="conceptInvoicingType === 1 ">
          <app-custom-checkbox formControlName="swAiu" [labelText]="'AIU'"></app-custom-checkbox>
        </div>
        <div class="col field-invoice-number" *ngIf="conceptInvoicingType === 1 ">
          <app-custom-input-number formControlName="invoiceNumber" [labelText]="'Nro.Factura'" [required]="true"></app-custom-input-number>
        </div>
        <div class="col field-sale-account" *ngIf="conceptInvoicingType === 1 ">
          <app-custom-input-text formControlName="saleAccount" [labelText]="'Cuenta Venta'"></app-custom-input-text>
        </div>
        <div class="col field-sale-devolution-account" *ngIf="conceptInvoicingType === 1 ">
          <app-custom-input-text formControlName="saleDevolutionAccount" [labelText]="'Cuenta Devolución Venta'"></app-custom-input-text>
        </div>
        <div class="col field-tax">
          <app-custom-inputgroup [inputValue]="codeNameTaxIva" [labelText]="'IVA'" [iconButton]="'pi pi-external-link'"
            [titleButton]="'Seleccionar IVA'" [required]="true"
            (onClick)="openTaxSelectionModal(true)"></app-custom-inputgroup>
          <app-custom-modal #taxIvaSelection [label]="'Seleccionar'" [header]="'Impuesto IVA'"
            [children]="componentTableSelection" [inputs$]="inputsForTaxSelection$" [output$]="output$"
            (selectedItems)="handleSelectedItem($event, true)" hidden></app-custom-modal>
        </div>
        <div class="col field-percent-tax">
          <app-custom-input-decimal [value]="percentIva" [labelText]="'% IVA'"
            [disabled]="true"></app-custom-input-decimal>
        </div>
        <div class="col field-tax">
          <app-custom-inputgroup [inputValue]="codeNameTaxRtf" [labelText]="'RFte'" [iconButton]="'pi pi-external-link'"
            [titleButton]="'Seleccionar RFte'" [required]="true"
            (onClick)="openTaxSelectionModal(false)"></app-custom-inputgroup>
          <app-custom-modal #taxRtfSelection [label]="'Seleccionar'" [header]="'Impuesto RFte'"
            [children]="componentTableSelection" [inputs$]="inputsForTaxSelection$" [output$]="output$"
            (selectedItems)="handleSelectedItem($event, false)" hidden></app-custom-modal>
        </div>
        <div class="col field-percent-tax">
          <app-custom-input-decimal [value]="percentRFte" [labelText]="'% RFte'"
            [disabled]="true"></app-custom-input-decimal>
        </div>
        <div class="field-buttons d-flex align-items-end justify-content-end mt-2 gap-2">
          <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [severity]="'success'"
            (onClick)="send()"></app-custom-button>
          <app-custom-button [title]="'Cancelar'" [label]="'Cancelar'" [severity]="'danger'"
            (onClick)="clearForm()"></app-custom-button>
        </div>
      </div>
    </form>
  </div>
</section>